import { DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierDriverMessageTable extends Layout {
    panelTaskFilters: Panel;
    sourceCarrierDriverMessage: DataSource;
    tableCarrierDriverMessage: Table;
}
